var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File Lockup / * Elements / FIle Format / CSV - Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-Lockup-/-*-Elements-/-FIle-Format-/-CSV---Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "txt-1-copy-14",
    fill: "#257F4E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.12,5.706 L18.292,0.88 C17.7286,0.319078 16.967,0.00287846 16.172,0 L3,0 C1.346,0 0,1.346 0,3 L0,29 C0,30.654 1.346,32 3,32 L21,32 C22.654,32 24,30.654 24,29 L24,7.828 C24,7.028 23.688,6.274 23.12,5.708 L23.12,5.706 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L6.66666667,0 L6.66666667,0 L6.66666667,2 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle-Copy-4",
    fill: "#F9818B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4 L6.66666667,4 L6.66666667,4 L6.66666667,6 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 Z",
    id: "Rectangle-Copy-49",
    fill: "#F8626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,8 L6.66666667,8 L6.66666667,8 L6.66666667,10 L1,10 C0.44771525,10 6.76353751e-17,9.55228475 0,9 C-6.76353751e-17,8.44771525 0.44771525,8 1,8 Z",
    id: "Rectangle-Copy-50",
    fill: "#DE5862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,0 L15,0 C15.5522847,2.96197961e-16 16,0.44771525 16,1 C16,1.55228475 15.5522847,2 15,2 L9.33333333,2 L9.33333333,2 L9.33333333,0 Z",
    id: "Rectangle-Copy-14",
    fill: "#F9818B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,4 L15,4 C15.5522847,4 16,4.44771525 16,5 C16,5.55228475 15.5522847,6 15,6 L9.33333333,6 L9.33333333,6 L9.33333333,4 Z",
    id: "Rectangle-Copy-51",
    fill: "#F8626E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,8 L15,8 C15.5522847,8 16,8.44771525 16,9 C16,9.55228475 15.5522847,10 15,10 L9.33333333,10 L9.33333333,10 L9.33333333,8 Z",
    id: "Rectangle-Copy-52",
    fill: "#DE5862"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.5d089456e0eec22c734d6c925f8caf8f.svg";
export { ForwardRef as ReactComponent };